import http from '@/utils/services/http'

export default {
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/arrematantes/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  findSimple (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/arrematantes/' + id + '/simple')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },

  lista (limit, page, filtros) {
    let url = '/api/arrematantes?page=' + page + '&limit=' + limit + filtros
    console.log(url)
    return http.get(url) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getArrematanteLances (id) {
    return http.get('/api/arrematantes/' + id + '/lances')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getArrematanteLotes (id) {
    return http.get('/api/arrematantes/' + id + '/lotes')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaStatus (arrematante, status, motivo) {
    return http.post('/api/arrematantes/' + arrematante + '/status/' + status + '?motivo=' + motivo)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaStatusDocumento (id, status) {
    return http.post('/api/arrematantes/documentos/' + id + '/status/' + status)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadDocumento (arrematante, documento) {
    return http.post('/api/arrematantes/' + arrematante + '/documentos/upload-documento', documento, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  removeDocumento (id) {
    return http.delete('/api/arrematantes/documentos/' + id + '/remove')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (arrematante, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(arrematante, id)
    }
    return http.post('/api/arrematantes/', arrematante)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/arrematantes/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  relatorioBasico (data) {
    return http.post('/api/arrematantes/relatorio/basico', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  exportMails () {
    return http.get('/api/arrematantes/export/emails')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  consultaAprovacoes () {
    return http.get('/api/arrematantes/aprovacoesPendentes')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  estatisticasCadastro () {
    return http.get('/api/arrematantes/estatisticasCadastro')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  incluirInadimplente (id, data) {
    return http.post('/api/inadimplentes/' + id + '/incluir', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  excluirInadimplente (id) {
    return http.post('/api/inadimplentes/' + id + '/excluir')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  incluirImpedimento (id, data) {
    return http.post('/api/impedimentos/' + id + '/incluir', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  excluirImpedimento (id) {
    return http.post('/api/impedimentos/' + id + '/excluir')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  excluirArrematante (id) {
    return http.delete('/api/arrematantes/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  analiseCadastral (id) {
    return http.get(`/api/arrematantes/${id}/analiseCadastral`)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getCampanhas (id) {
    return http.get('/api/lista-comunicacao-arrematante/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  restringirLance (id, restringir = false) {
    return http.post(`/api/arrematantes/${id}/restricaoLance`, {
      restringir: restringir
    })
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/arrematantes/services/index.js